export const analyticsDataArabic = {
    analyticsDataContent: {
        mainHeading: "متخصصون في حلول التحليلات الخاصة بك",
        greenHeading: "احتياجات الصناعة",
        sectionDescription: "نحن ندرك أن لكل قطاع تحدياته وفرصه الخاصة. ولذلك، نقدم حلولاً تحليلية خاصة بكل قطاع، مصممة لتلبية احتياجاتكم الأكثر إلحاحاً.",
        buttonText: "استكشاف جميع الصناعات"
    },
    analyticsDataCards: [
        {
            title: "تحليلات إدارة علاقات العملاء (CRM)",
            description: "توفر حلول تحليلات إدارة علاقات العملاء (CRM) لدينا رؤى عميقة حول تفاعلات العملاء، مما يساعدك على تحسين علاقات العملاء، وتحسين معدلات الاحتفاظ، وتعزيز الرضا العام.",
            icon: 'CRM.png'
        },
        {
            title: "تحليلات العملاء",
            description: "نقوم بتحليل سلوك العملاء لمساعدتك على فهم التفضيلات، والتنبؤ بالاتجاهات، وتخصيص التجارب، مما يؤدي إلى زيادة الولاء وارتفاع معدلات التحويل.",
            icon: 'Customer-ANALYTICS.png'
        },
        {
            title: "تقييم المخاطر المالية",
            description: "توفر حلول تحليلات الموارد البشرية لدينا رؤى قيمة في إدارة القوى العاملة، مما يمكّنك من تحسين التوظيف، وتحسين أداء الموظفين، وتقليل معدل دوران الموظفين.",
            icon: 'RISK-ASSESMENTS.png'
        },
        {
            title: "تحليلات الموارد البشرية",
            description: "استفد من تحليلات مبيعاتنا لتحديد الاتجاهات، والتنبؤ بالمبيعات، وتحسين استراتيجيات مبيعاتك، مما يضمن تحقيق أهدافك ودفع نمو الإيرادات.",
            icon: 'HR-ANALYTICS.png'
        },
        {
            title: "تحليلات المبيعات",
            description: "نحن نقدم تحليلات تسويقية شاملة لتتبع أداء الحملات، وفهم رحلات العملاء، وتحسين جهودك التسويقية لتحقيق أقصى عائد على الاستثمار.",
            icon: 'SALES-ANALYTICS.png'
        },
        {
            title: "التحليلات التنبؤية",
            description: "تعزز حلول تحليلات سلسلة التوريد لدينا الكفاءة التشغيلية من خلال توفير رؤى حول إدارة المخزون، وتنبؤ الطلب، وتحسين اللوجستيات.",
            icon: 'PREDICTIVE-ANALYSIS.png'
        },
        {
            title: "تحليلات التسويق",
            description: "نحن نساعدك على تقييم وإدارة المخاطر المالية من خلال تحليلاتنا المتقدمة، مما يتيح اتخاذ قرارات أفضل ويضمن الاستقرار المالي.",
            icon: 'MARKETING-ANALYTICS.png'
        },
        {
            title: "تحليلات سلسلة التوريد",
            description: "تسمح لك حلول التحليلات التنبؤية لدينا بتوقع تغيرات السوق، وتحسين الاستراتيجيات، واتخاذ قرارات استباقية تبقيك في صدارة المنافسة.",
            icon: 'SUPPLY-CHAIN-ANALYTICS.png'
        }
    ]
}